
  <section class="home-banner-sec"[style.backgroundImage]="'url('+homePageImage+')'">
    <div class="container">
      <h1 data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100" [innerText]="pageHomeData?.title">
        </h1>
        <p data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100" [innerText]="pageHomeData?.description"></p>
        <a data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1100"  class="btn btn-primary" [routerLink]="['/how-it-works']" >How it Works</a>

    </div>
  </section>
  <section class="how-it-works-sec">

      <div class="container">
        <h2 class="site-title text-center mt-3 mb-4">{{pageData?.title}}</h2>
        <div class="mt-5"></div>
        <div class="custom-tabs appPreviewUl">
          <ul class="justify-content-start nav nav-pills mb-4">
            <li class="nav-item">
              <a href="javascript:void(0);" (click)='appPreview(1)' class="nav-link" [class.active]="appPreviewId==1">Customer
                App</a>
            </li>
            <li class="nav-item">
              <a href="javascript:void(0);" (click)='appPreview(2)' class="nav-link" [class.active]="appPreviewId==2">Driver
                App</a>
            </li>
          </ul>
        </div>



        <div *ngIf="appPreviewId==1">
          <div class="row">
            <div class="col-lg-6 order-lg-last">
              <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                <img class="img-responsive"
                  [src]="pageData?.jsonKey[0]?.customer[0]?.image? pageData?.jsonKey[0]?.customer[0]?.image: 'assets/img/howit-1.png'">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="h-i-w-text h-i-w-text-1">
                <h4 data-number="1">{{pageData?.jsonKey[0]?.customer[0]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.customer[0]?.description"></p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="h-i-w-img" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100">
                <!-- <img class="img-responsive"
                  [src]="pageData?.jsonKey[0]?.customer[1]?.image? pageData?.jsonKey[0]?.customer[1]?.image:'assets/img/howit-2.png'"> -->
                    <img class="img-responsive" src="assets/img/howit-2.png">
              </div>
            </div>
            <div class="col-lg-6">

              <img class="how-it-works-dots" src="assets/img/dots.png">
              <div class="h-i-w-text h-i-w-text-2">
                <h4 data-number="2">{{pageData?.jsonKey[0]?.customer[1]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.customer[1]?.description"></p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 order-lg-last">
              <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                <!-- <img class="img-responsive"
                  [src]="pageData?.jsonKey[0]?.customer[2]?.image? pageData?.jsonKey[0]?.customer[2]?.image:'assets/img/howit-3.png'"> -->
                  <img class="img-responsive" src="assets/img/howit-3.png">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="h-i-w-text h-i-w-text-3">
                <h4 data-number="3">{{pageData?.jsonKey[0]?.customer[2]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.customer[2]?.description"></p>
              </div>
            </div>
          </div>
        </div>



        <div *ngIf="appPreviewId==2">
          <div class="row">
            <div class="col-lg-6 order-lg-last">
              <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                <img class="img-responsive"
                  [src]="pageData?.jsonKey[0]?.driver[0]?.image? pageData?.jsonKey[0]?.driver[0]?.image:'assets/img/howit-1.png'">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="h-i-w-text h-i-w-text-1">
                <h4 data-number="1">{{pageData?.jsonKey[0]?.driver[0]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.driver[0]?.description"></p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="h-i-w-img" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100">
                <img class="img-responsive"
                  [src]="pageData?.jsonKey[0]?.driver[1]?.image? pageData?.jsonKey[0]?.driver[1]?.image:'assets/img/howit-12.png'">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="h-i-w-text h-i-w-text-2">
                <h4 data-number="2">{{pageData?.jsonKey[0]?.driver[1]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.driver[1]?.description"></p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 order-lg-last">
              <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                <!-- <img class="img-responsive"
                   [src]="pageData?.jsonKey[0]?.driver[2]?.image? pageData?.jsonKey[0]?.driver[2]?.image:'assets/img/howit-13.png'"> -->
                  <img class="img-responsive"
                   src='assets/img/howit-13.png'>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="h-i-w-text h-i-w-text-3">
                <h4 data-number="3">{{pageData?.jsonKey[0]?.driver[2]?.title}}</h4>
                <p [innerHTML]="pageData?.jsonKey[0]?.driver[2]?.description"></p>
              </div>
            </div>
          </div>

        </div>



      </div>
  </section>


  <section class="aboutus-sec">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="aboutus-img" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100">
            <img [src]="pageHomeData?.jsonKey[0]?.content[0]?.image? pageHomeData?.jsonKey[0]?.content[0]?.image: 'assets/img/aboutus-img.png'">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="aboutus-text" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
            <h2 class="site-title mt-5 mb-3">{{pageHomeData?.jsonKey[0]?.content[0]?.title}}</h2>
          <p [innerHTML]="pageHomeData?.jsonKey[0]?.content[0]?.description"></p>

          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="app-download-sec">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7">
          <div class="app-img text-center">
            <img class="circle-bubble" src="assets/img/circle-bubble.png">
            <img class="img-responsive" data-aos="fade-up" data-aos-duration="1100" *ngIf="appPreviewId==1" [src]="pageHomeData?.jsonKey[0]?.content[1]?.image? pageHomeData?.jsonKey[0]?.content[1]?.image:'assets/img/app-1.png'">
            <img class="img-responsive" data-aos="fade-up" data-aos-duration="1100" *ngIf="appPreviewId==2" [src]="'assets/img/app-2.png'">
          </div>
        </div>
        <div class="col-lg-5">
          <div class="app-text" data-aos="fade-down" data-aos-duration="1300">
            <h2 class="font-weight-bold mb-3">{{pageHomeData?.jsonKey[0]?.content[1]?.title}}</h2>
            <p class="mb-5" [innerHTML]="pageHomeData?.jsonKey[0]?.content[1]?.description"></p>
            <div class="custom-tabs appPreviewUl">
              <ul class="justify-content-start nav nav-pills mb-4" style="justify-content: start !important;">
                <li class="nav-item bg-white">
                  <a href="javascript:void(0);" (click)='appPreview(1)'  class="nav-link"  [class.active]="appPreviewId==1">Customer App</a>
                </li>
                <li class="nav-item bg-white">
                  <a href="javascript:void(0);" (click)='appPreview(2)' class="nav-link" [class.active]="appPreviewId==2">Driver App</a>
                </li>
              </ul>
            </div>
            <div>
              <img class="mr-3" src="assets/img/playstore.png">
              <img class="" src="assets/img/appstore.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
    <section class="passenger-sec">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 order-lg-last">

            <div class="passinger-img" data-aos="fade-left" data-aos-duration="1300">
              <div class="user-circle">
                  <img (click)="userTesti(item._id)" *ngFor="let item of testimonial;let i = index" [class.active]="activeTest?._id===item._id" class="user-icon user-icon-{{i+1}}" [src]="item?.image">
                  <img id="user-icon-main" class="user-icon user-icon-main" [src]="activeTest?.image">
              </div>
            </div>
          </div>
          <div class="col-lg-6 overflow-hidden">
            <i class="fa fa-quote-left passinger-quote" aria-hidden="true"></i>
            <h2 class="site-title text-uppercase">
              what Passenger think about us</h2>
            <div class="passinger-text animate__animated animate__fadeInRight" *ngIf="userTestiId==activeTest?._id">
                <p [innerHTML]="activeTest?.text"></p>
                <div class="passinger-name">{{activeTest?.name}}</div>
                <div class="passinger-degignation">{{activeTest?.designation}}</div>
            </div>
          </div>
        </div>

      </div>
    </section>
    <section class="faq-sec">
      <div class="container">
        <h2 class="site-title text-center mb-5">Frequently Asked Questions</h2>
        <div class="" data-aos="fade-up " data-aos-duration="1100">
          <ngb-accordion [closeOthers]="true" >
            <ngb-panel  *ngFor="let item of faq" [title]="item.question">
              <ng-template ngbPanelContent>
              {{item.answer}}
              </ng-template>
            </ngb-panel>

          </ngb-accordion>
        </div>
      </div>
    </section>
